import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { motion } from "framer-motion";

const API_URL = 'https://backend.aktcorp.com/compliances';

export const DeleteNews = () => {
  const [news, setNews] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPage, setShowPage] = useState(false);

 const token = localStorage.getItem("authToken");

  const headers = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json",
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPage(true);
      fetchCompliances();
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const fetchCompliances = async () => {
    try {
      const response = await axios.get(API_URL, { headers });
      setNews(response.data.data || []);
    } catch (error) {
      console.error("Error fetching compliances:", error);
      setErrorMessage("Failed to load compliances. Please try again.");
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);
    setErrorMessage("");
    setSuccessMessage("");

    try {
      await axios.delete(`${API_URL}/${id}`, { headers });
      setNews((prev) => prev.filter((item) => item.id !== id));
      setSuccessMessage("Compliance deleted successfully!");
    } catch (error) {
      console.error("Error deleting compliance:", error);
      setErrorMessage("Failed to delete compliance. Please try again.");
    } finally {
      setTimeout(() => {
        setLoading(false);
        setDeleteId(null);
        setSuccessMessage("");
        setErrorMessage("");
      }, 1500);
    }
  };

  if (!showPage) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: "linear" }}
          className="w-16 h-16 border-4 border-t-transparent border-blue-600 rounded-full"
        ></motion.div>
      </div>
    );
  }


  return (
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-md rounded-lg mb-10">
      <motion.h2
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-3xl font-bold text-gray-900 text-center mb-4 bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text"
      >
        Delete Image & PDF
      </motion.h2>

      {errorMessage && <p className="text-red-500 text-center">{errorMessage}</p>}
      {successMessage && <p className="text-green-500 text-center">{successMessage}</p>}

      <ul>
        {news.length > 0 ? (
          news.map((item) => (
            <li key={item.id} className="border-b py-3 flex justify-between items-center">
              <div className="flex items-center">
                {item.imageUrl && (
                  <img
                    src={item.imageUrl}
                    alt="News"
                    className="w-16 h-16 object-cover rounded-lg shadow-md border"
                  />
                )}
              </div>
              <button
                onClick={() => setDeleteId(item.id)}
                className="text-red-500 text-lg font-semibold hover:text-red-700 transition duration-200"
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            </li>
          ))
        ) : (
          <p className="text-center text-gray-500 mt-5">No records found.</p>
        )}
      </ul>

      {/* Delete Confirmation Modal */}
      {deleteId && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
            className="bg-white p-6 rounded-lg shadow-lg max-w-xs w-full text-center"
          >
            <h2 className="text-xl font-bold mb-2 text-red-600">DELETE?</h2>
            <p className="text-red-600 mb-3">Are you sure you want to delete this?</p>

            <div className="flex justify-between">
              {loading ? (
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ repeat: Infinity, duration: 0.8, ease: "linear" }}
                  className="w-6 h-6 border-4 border-red-500 border-t-transparent rounded-full mx-auto"
                ></motion.div>
              ) : (
                <div className="flex gap-6">
                  <button
                    onClick={() => handleDelete(deleteId)}
                    className="bg-red-500 text-white px-6 py-2 rounded-md hover:bg-red-700 transition duration-200"
                  >
                    Yes
                  </button>
                  <button
                    onClick={() => setDeleteId(null)}
                    className="bg-gray-500 text-white px-6 py-2 ml-20 rounded-md hover:bg-gray-700 transition duration-200"
                    disabled={loading}
                  >
                    No
                  </button>
                </div>
              )}
            </div>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default DeleteNews;
